import { BehaviorSubject } from "rxjs";
import { IAutocompleteFormControlOptions } from "../autocomplete-form-control";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";
import { _SSDataSourceBase } from "./utils/ss-data-source-base";

export class SSAutocompleteOptions extends _SSDataSourceBase implements _SSControlOptionsBase<'autocomplete'> {

  listItemsSubject = new BehaviorSubject<IAutocompleteFormControlOptions['listItems']>([]);

  readonly hintWithSubject = new BehaviorSubject<string>(undefined);

  constructor(
    private _initialOptions?: IAutocompleteFormControlOptions
  ) {
    super();
    this._initOptions();

  }

  readonly allowCustomValuesSubject = new BehaviorSubject<boolean>(false);


  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'autocomplete'>(this, this._initialOptions);

  }

  dispose() {
    this.listItemsSubject.complete()
  }
}
